import { createApp } from 'vue';
import App from './App.vue';
import router from './router.js'; // Import your router
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue3Lottie from 'vue3-lottie'; //lottie blob animation

// vuetify styles
import 'vuetify/styles'
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({ components, directives })

createApp(App)
    .use(vuetify)
    .use(router, Vue3Lottie)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app');

library.add(fas);
